import { render, staticRenderFns } from "./prontuario_paciente.vue?vue&type=template&id=1462aa3e&scoped=true"
import script from "./prontuario_paciente.vue?vue&type=script&lang=js"
export * from "./prontuario_paciente.vue?vue&type=script&lang=js"
import style0 from "./prontuario_paciente.vue?vue&type=style&index=0&id=1462aa3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1462aa3e",
  null
  
)

export default component.exports